import {
    gridPageCountSelector,
    useGridApiContext,
    useGridSelector,
    GridFooter,
} from '@mui/x-data-grid-pro'

function SkyBaseDataGridFooter() {
    const apiRef = useGridApiContext()
    const pageCount = useGridSelector(apiRef, gridPageCountSelector)

    if (pageCount <= 1) {
        return null
    }

    return (
        <GridFooter />
    )
}

export default SkyBaseDataGridFooter
